module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-instructions",
    attrs: {
      "block": "lightest"
    }
  }, [_c('h2', {
    staticClass: "h2 home-instructions__heading mt0"
  }, [_vm._v("You play a critical role in driving quality in dentistry")]), _vm._v(" "), _c('div', {
    staticClass: "home-instructions__inner group group--last"
  }, [_c('div', {
    staticClass: "home-instructions__steps"
  }, _vm._l((_vm.instructionSteps), function(step, index) {
    return _c('div', {
      key: index,
      staticClass: "home-instructions__step"
    }, [_c('div', {
      staticClass: "home-instructions__icon"
    }, [_c('img', {
      attrs: {
        "src": step.image,
        "alt": step.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "home-instructions__content"
    }, [_c('h4', {
      staticClass: "home-instructions__heading h4 fw-bold"
    }, [_vm._v(_vm._s(step.heading))]), _vm._v(" "), _c('p', {
      staticClass: "p",
      domProps: {
        "innerHTML": _vm._s(step.copy)
      }
    })])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd1e9bb2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/infoDentists/Instructions.vue
// module id = 272
// module chunks = 0